<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import OrcamentosTable from './orcamentos-table'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/orcamentos_anim.json'
import exportFromJSON from "export-from-json"
import DropZone from "@/components/widgets/dropZone.vue";
import { ref } from "vue";
import useVuelidate from "@vuelidate/core";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Orçamentos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { DropZone, Layout, PageHeader, OrcamentosTable, Loader, Vue3Lottie, },

  data() {
    return {

      animationJson,
      title: 'Orçamentos',
      items: [
        {
          text: 'Comercial',
          href: '/',
        },
        {
          text: 'Orçamentos',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      orctoList: null,
      orctoChart1: null,
      orctoChart2: null,
      pesqTextFilter: '',
      statusFilter: 'DF',
      valorTotal: 0,
      valorTotalConf: 0,
      valorTotalElab: 0,
      valorTotalFat: 0,
      showModalImport: false,
      submittedAnexo: false,
      descranexo: '',

    }
  },


  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };

    // return { dropzoneFile, drop};
    return { v$: useVuelidate(), dropzoneFile, drop };
  },

  mounted() {
    console.log('mounted orcamentos-list_0')

    this.atualizaDataList()
  },

  methods: {
    cancelarImportExcel() {
      this.descranexo = ''
      this.dropzoneFile = ''
      this.showModalImport = false
    },

    atualizaPagina() {
      window.location.reload();
    },

    confImportar() {
      console.log('confImportar')

      let arquivo = document.querySelector(".dropzoneFile").files[0]
      let formData = new FormData()
      formData.append("file", arquivo)
      this.showModalImport = false
      this.loadingList = true

      api.post(`${getBaseUrl()}api/orctoimpfile`, formData, { // movfileanexo
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        console.log('then axios confImportar')
        console.log(res)
        this.loadingList = false


        //Tratando mensagem de retorno para o usuário
        if (res.data.success === false) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: 'Erro de importação do excel',
            text: res.data.message,
            showConfirmButton: false,
            timer: 2500
          }).then(() => {
            this.descranexo = ''
            this.dropzoneFile = ''

            // this.atualizaPagina()
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações importadas com sucesso!",
            showConfirmButton: false,
            timer: 3000
          }).then(() => {
            this.$router.push(`/orcamento/editar/${res.data.id}`)
          })
        }

        // this.mediasData = res.data[0]
        // this.loadingFiles = false
        //
        // this.showModaleditarPed = false
        //
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Informações salvas com sucesso!",
        //   showConfirmButton: false,
        //   timer: 1500
        // })

      }).catch((err) => {

        console.log('erro axios')
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.loadingFiles = false
      }).then(() => {
        this.descranexo = ''
        this.dropzoneFile = ''

        // this.atualizaPagina()
      })
    },

    selectedFile() {
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')
    },


    emitRelat001() {
      console.log('emitRelat001')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relorc01`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_orcamentos_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    emitRelat002() {
      console.log('emitRelat002')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relorc02`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_orcamentos_002.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    emitRelat003() {
      console.log('emitRelat003')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relorc03`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_orcamentos_003.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },


    exportExcel() {
      console.log('exportExcel')
      const data = this.orctoList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },


    importExcel() {
      console.log('importExcel')
      this.showModalImport = true
      // const data = this.orctoList
      // const fileName = "exp_dados";
      // const exportType = exportFromJSON.types.xls;
      // if (data) exportFromJSON({ data, fileName, exportType });
    },


    atualizaDataList() {
      this.loadingList = true
      api.get(`${getBaseUrl()}api/orcamentos`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data[1])
        this.orctoList = res.data[0]
        this.title = `(${this.orctoList.length}) Orçamentos`
        this.loadingList = false

        // console.log('orcamentosChart1')
        // console.log(orcamentosChart1)


        let valorTotalLoc = 0
        let valorTotalConf = 0
        let valorTotalElab = 0
        let valorTotalFat = 0
        this.orctoList.forEach((value) => {

          valorTotalLoc += value.valorliq

          if (value.status === 'EL') {
            valorTotalElab += value.valorliq
          } else if (value.status === 'CO') {
            valorTotalConf += value.valorliq
          } else if (value.status === 'FA') {
            valorTotalFat += value.valorliq
          }

        })

        this.valorTotal = valorTotalLoc
        this.valorTotalElab = valorTotalElab
        this.valorTotalConf = valorTotalConf
        this.valorTotalFat = valorTotalFat




        let labelsLocG1 = []
        let series01G1 = []
        let series02G1 = []
        res.data[1].forEach((value) => {
          // console.log(value)
          labelsLocG1.push(value.month)
          if (value.status === 'FA') {
            series01G1.push(value.valor)
          } else {
            series02G1.push(value.valor)
          }
        })
        const uniquelabelsLocG1 = [...new Set(labelsLocG1)]
        // console.log('series02G1')
        // console.log(series02G1)
        this.orctoChart1 = {
          series: [{
            name: 'Faturados',
            type: 'column',
            data: series01G1
          },
          {
            name: 'Outros',
            type: 'line',
            data: series02G1
          }],
          chartOptions: {
            chart: {
              stacked: false,
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              width: 2,
              curve: 'smooth'
            },
            plotOptions: {
              bar: {
                columnWidth: '20%',
                endingShape: 'rounded'
              }
            },
            colors: ['#34c38f', '#556ee6'],
            fill: {
              gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                //stops: [0, 100, 100, 100]
              }
            },
            labels: uniquelabelsLocG1,
            markers: {
              size: 0
            },
            yaxis: {
              min: 0
            },
          }
        }

        let labelsLocG2 = []
        let series01G2 = []
        let valorTotal = 0.00
        res.data[2].forEach((value) => {
          valorTotal += parseInt(value.valor)
        })
        console.log('valorTotal_G2')
        console.log(valorTotal)
        res.data[2].forEach((value) => {
          console.log(value)
          labelsLocG2.push(value.nome)

          const valorPerc = parseInt(value.valor / valorTotal * 100)
          console.log(valorPerc)

          series01G2.push(valorPerc)
        })
        this.orctoChart2 = {
          series: series01G2,
          chartOptions: {
            plotOptions: {
              radialBar: {
                dataLabels: {
                  name: {
                    fontSize: '22px',
                  },
                  value: {
                    fontSize: '16px',
                  },
                  total: {
                    show: true,
                    label: 'Total',
                    // eslint-disable-next-line no-unused-vars
                    formatter: function (w) {
                      // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                      return valorTotal
                    }
                  }
                }
              }
            },
            labels: labelsLocG2,
            colors: ['#ff5900', '#ff9c00', '#3ec334', '#4cf1b7', '#f46a6a'],
          }
        }



        this.loadingGraph = false
      });
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/orcamento`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    }


  },
}

</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 70px; right: 250px;">
      <Vue3Lottie :animationData="animationJson" :height="150" :width="150" />
    </span>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input id="inputPesquisa" type="text" v-model="pesqTextFilter" class="form-control"
                      placeholder="Enter para pesquisar..." @change="atualizaDataList" />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select id="selectStatus" v-model="statusFilter" @change="atualizaDataList"
                      class="form-control select2-search-disable">
                      <option value="DF" selected>EL / CA</option>
                      <option value="T" selected>Todos</option>
                      <option value="CO">Confirmado</option>
                      <option value="EL">Elaboração</option>
                      <option value="FA">Fatrurado</option>
                      <option value="CA">Cancelados</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">

                <b-dropdown ngbDropdown menu-class="dropdown-menu-md dropdown-menu-end" right variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div v-if="!loadingList">
                    <div class="dropdown-item-text">
                      <div>
                        <p class="text-muted mb-2">Total</p>
                        <h5 class="mb-0">{{ formatDecimal(valorTotal) }} (Valor Total) </h5>
                      </div>
                    </div>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item>
                      Faturado:
                      <span class="float-end"> {{ formatDecimal(valorTotalFat) }} (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Confirmado:
                      <span class="float-end"> {{ formatDecimal(valorTotalConf) }} (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Com Elaboração:
                      <span class="float-end"> {{ formatDecimal(valorTotalElab) }} (0%)</span>
                    </b-dropdown-item>



                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center" @click="importExcel" href="javascript: void(0);">
                      Importar Excel
                    </a>


                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center" @click="exportExcel" href="javascript: void(0);">
                      Exportar Excel
                    </a>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center" @click="emitRelat001" href="javascript: void(0);">
                      Relatório de Orçamentos Diário
                    </a>

                    <a class="dropdown-item text-primary text-center" @click="emitRelat002" href="javascript: void(0);">
                      Relatório de Orçamentos Mês
                    </a>

                    <a class="dropdown-item text-primary text-center" @click="emitRelat003" href="javascript: void(0);">
                      Orçamentos por Representante
                    </a>

                  </div>

                </b-dropdown>
              </div>



              <div class="col-sm-7">
                <div class="text-sm-end">
                  <router-link :to="`/orcamento/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2">
                      <i class="mdi mdi-plus me-1"></i> Novo Orçamento
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <OrcamentosTable v-if="!loadingList" :orctoList="orctoList" @deletareg="deletaReg" />

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>


    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Mensal</h4>
            <apexchart class="apex-charts" type="line" height="370" :series="orctoChart1.series"
              :options="orctoChart1.chartOptions"></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Clientes Destaque Semana</h4>
            <apexchart class="apex-charts" height="370" type="radialBar" dir="ltr" :series="orctoChart2.series"
              :options="orctoChart2.chartOptions"></apexchart>

          </div>
        </div>
      </div>

    </div>



    <b-modal title="Criar Novo Anexo" v-model="showModalImport" centered hide-footer @hidden="cancelarImportExcel">
      <div>
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input id="descranexo" type="text" v-model="descranexo" class="form-control"
                  placeholder="Descrição do anexo" :class="{ 'is-invalid': submittedAnexo && !descranexo }" />
                <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="cancelarImportExcel">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confImportar">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


  </Layout>
</template>
